import { SessionProvider } from 'next-auth/react'
import type { AppProps } from 'next/app'

import Head from 'next/head'
import '../styles/globals.css'

function MyApp({ Component, pageProps: { session, ...pageProps } }: AppProps) {
  return (
    <>
      <Head>
        <title>MuseAI | 人机共创想象力的未来</title>
      </Head>
      <SessionProvider session={session}>
        <Component {...pageProps} />
      </SessionProvider>
    </>
  )
}

export default MyApp
